import axios from "../../../core/api/http-common";

const ON_GET_ADMIN_DASHBOARD = "/users/get/dashboard";
const ON_CREATE = "/users/create";
const ON_GET_TEAM_WITH_PAGINATION = "/users/get/with/pagination";
const ON_GET_TEAM_MEMBER_DETAILS_INFOS = "/users/get/details/informations";
const ON_GET_TEAM_MEMBER_DOCUMENTS = "/users/get/documents";
const ON_DELETE_TEAM_MEMBER_DOCUMENTS = "/users/delete/documents";

export function onGetAdminDashboard(axiosPrivate, _data, signal) {
  const data = {
    inscription_id: _data?.inscription_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_ADMIN_DASHBOARD, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function onCreateTeamMember(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_CREATE, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function onGetTeamMembers(axiosPrivate, _data, signal) {
  const data = {
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_TEAM_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetTeamMemberDetailsInformations(
  axiosPrivate,
  _data,
  signal,
) {
  const data = {
    curren_team_member_id: _data?.curren_team_member_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_TEAM_MEMBER_DETAILS_INFOS, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetTeamMemberDocuments(
  axiosPrivate,
  _data,
  signal,
) {
  const data = {
    curren_team_member_id: _data?.curren_team_member_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_TEAM_MEMBER_DOCUMENTS, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onDeleteTeamMemberDocuments(axiosPrivate, _data) {
  const data = {
    document_id: _data?.document_id,
    document_title: _data?.document_title,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .delete(ON_DELETE_TEAM_MEMBER_DOCUMENTS, {
        params: data,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Student
const ON_GET_STUDENT_DASHBOARD = "/users/get/student/dashboard";
export function onGetStudentDashboard(axiosPrivate, _data, signal) {
  const data = {
    inscription_id: _data?.inscription_id,
    stream_id: _data?.stream_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_STUDENT_DASHBOARD, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Notifications
const ON_NOTIFICATION_CREATE = "/users/create/notification";
export function onCreateNotification(axiosPrivate, data) {
  const _data = {
    inscription_id: data?.inscription_id,
    selectedStream: data?.selectedStream,
    subject: data?.subject,
    description: data?.description,
    dates: data?.dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_NOTIFICATION_CREATE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
const ON_GET_NOTIFICATIONS = "/users/get/notifications";
export function onGetNotifications(axiosPrivate, _data, signal) {
  const data = {
    inscription_id: _data?.inscription_id,
    sys_role: _data?.sys_role,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_NOTIFICATIONS, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
const ON_GET_NOTIFICATIONS_RELEASED = "/users/get/notifications/release";
export function onGetNotificationsReleased(axiosPrivate, data) {
  const _data = {
    notification_id: data?.notification_id,
    status: data?.status,
    dates: data?.dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .patch(ON_GET_NOTIFICATIONS_RELEASED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Chats - Discussions
const ON_GET_DISCUSSIONS = "/users/get/discussions";
const ON_GET_DISCUSSIONS_MESSAGES = "/users/get/discussions/messages";
const ON_MESSAGES_CREATE = "/users/create/discussions/messages";
export function onGetDiscussions(axiosPrivate, _data) {
  const data = {
    inscription_id: _data?.inscription_id,
    dates: _data?.dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_DISCUSSIONS, {
        params: data,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetDiscussionsMessages(axiosPrivate, _data) {
  const data = {
    inscription_id: _data?.inscription_id,
    participant_id: _data?.participant_id,
    dates: _data?.dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_DISCUSSIONS_MESSAGES, {
        params: data,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onCreateMessages(axiosPrivate, data) {
  const _data = {
    mode: data?.mode,
    type: data?.type,
    content: data?.content,
    status: data?.status,
    sender_id: data?.inscription_id,
    participant_id: data?.participant_id,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_MESSAGES_CREATE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
